// @flow
export const INIT = 'INIT';

export const LIFECYCLE_START = 'LIFECYCLE_START';
export const LIFECYCLE_MAIN_MENU = 'LIFECYCLE_MAIN_MENU';
export const LIFECYCLE_GAME_ENTER = 'LIFECYCLE_GAME_ENTER';
export const LIFECYCLE_GAME_LOAD = 'LIFECYCLE_GAME_LOAD'; // OK
export const LIFECYCLE_GAME_SHOW_READY = 'LIFECYCLE_GAME_SHOW_READY';
export const LIFECYCLE_GAME_START = 'LIFECYCLE_GAME_START';
export const LIFECYCLE_GAME_PAUSE = 'LIFECYCLE_GAME_PAUSE';
export const LIFECYCLE_GAME_PAUSE_END = 'LIFECYCLE_GAME_PAUSE_END';
export const LIFECYCLE_ATOMS_EXPLODE = 'LIFECYCLE_ATOMS_EXPLODE';
export const LIFECYCLE_ATOMS_EXPLODE_END = 'LIFECYCLE_ATOMS_EXPLODE_END';
export const LIFECYCLE_COUNT_SCORE = 'LIFECYCLE_COUNT_SCORE';
export const LIFECYCLE_COUNT_SCORE_END = 'LIFECYCLE_COUNT_SCORE_END';
export const LIFECYCLE_GAME_OVER = 'LIFECYCLE_GAME_OVER';
export const LIFECYCLE_GAME_WIN = 'LIFECYCLE_GAME_WIN';
export const LIFECYCLE_GAME_NEXT_LEVEL = 'LIFECYCLE_GAME_NEXT_LEVEL';

export const CLOCK_TICK = 'CLOCK_TICK';

export const GAME_LOAD_LEVEL = 'GAME_LOAD_LEVEL'; // ?

export const GAME_UI_TOUCH = 'GAME_UI_TOUCH'; // OK
export const GAME_UI_TOUCH_LEAN = 'GAME_UI_TOUCH_LEAN'; // OK
export const GAME_UI_TOUCH_RELEASE = 'GAME_UI_TOUCH_RELEASE'; // OK
export const GAME_UI_ATOM_MOVE = 'GAME_UI_ATOM_MOVE'; // OK
export const GAME_UI_ATOM_MOVE_END = 'GAME_UI_ATOM_MOVE_END'; // OK

export const GAME_LEVEL_WIN = 'GAME_LEVEL_WIN';
export const GAME_LEVEL_LOSE = 'GAME_LEVEL_LOSE';

export const GAME_UI_CURSOR_MOVE_START = 'GAME_UI_CURSOR_MOVE_START';
export const GAME_UI_CURSOR_MOVE_END = 'GAME_UI_CURSOR_MOVE_END';
export const GAME_UI_CURSOR_SELECT = 'GAME_UI_CURSOR_SELECT';
export const GAME_UI_CURSOR_UNSELECT = 'GAME_UI_CURSOR_UNSELECT';



// WEBPACK FOOTER //
// ./src/app/redux/actionTypes.js